<template>
  <a-space size="middle">
    <UserAvatar :avatar-url="user.avatarUrl" />
    <a-space
      direction="vertical"
      :size="2"
    >
      <div>
        {{ user.nickname || user.name }}
      </div>
      <div class="text-caption">
        {{ user.mainDepartmentId?.displayName }}
      </div>
    </a-space>
  </a-space>
</template>

<script>
import UserAvatar from '@/components/UserAvatar'

export default {
  name: 'MentionUser',
  components: {
    UserAvatar
  },
  props: {
    user: {
      type: Object,
      required: true
    }
  }
}
</script>
